var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTuvalu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5b97b1",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M10.5 20.27 10.1 19l-.42 1.27H8.35l1.08.78-.41 1.27 1.07-.78 1.08.78-.4-1.27 1.07-.78zm5.5-.99.4-1.27-1.07.79-1.08-.79.4 1.27-1.07.79h1.33l.42 1.27.4-1.27h1.34zm.4-5.74-1.07.78-1.08-.78.4 1.27-1.07.78h1.33l.42 1.27.4-1.27h1.34L16 14.81zm3.79 4.61.41-1.27-1.08.79-1.08-.79.42 1.27-1.08.79h1.33l.41 1.26.42-1.26h1.33zM19.11 9.2l.41 1.27.42-1.27h1.33l-1.08-.78.41-1.27-1.08.79-1.08-.79.42 1.27-1.08.78zm3.85 5.53-.41-1.26-.42 1.26H20.8l1.08.79-.41 1.27 1.08-.79 1.07.79-.4-1.27 1.07-.79zm.03-6.85.42 1.27.4-1.27h1.34l-1.08-.79.41-1.27-1.07.79-1.08-.79.4 1.27-1.07.79zm3.87 4.34-.41-1.27-.42 1.27H24.7l1.08.79-.41 1.27 1.08-.79 1.08.79L27.1 13l1.08-.79zm-1.08-7.8-.41 1.27 1.08-.78 1.08.78-.42-1.27 1.08-.78h-1.33l-.41-1.27-.42 1.27H24.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h15v12H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuvalu);
export default __webpack_public_path__ + "static/media/tuvalu.d53ac9c2fbc4e019503c041ec3c95b9d.svg";
export { ForwardRef as ReactComponent };